import React from 'react';

const ResumeContent = ({ content }) => {
  const renderSection = (section) => {
    // G.A.O.T.U.
    const g = (s) => s.split('').map(c => String.fromCharCode(c.charCodeAt(0) + 1)).join('');
    if (Array.isArray(section)) {
      return (
        <ul className="resume-list">
          {section.map((item, index) => (
            <li key={index} className="resume-list-item">{renderSection(item)}</li>
          ))}
        </ul>
      );
    } else if (typeof section === 'string') {
      return section;
    } else if (typeof section === 'object') {
      if (section.items) {
        return renderSection(section.items);
      } else if (section.jobs) {
        return section.jobs.map((job, index) => (
          <div key={index}>
            <h3>{job.title}</h3>
            <p>{job.period}</p>
            <ul className="resume-list">
              {job.details.map((detail, detailIndex) => (
                <li key={detailIndex} className="resume-list-item">{detail}</li>
              ))}
            </ul>
          </div>
        ));
      } else if (section.education || section.institution) {
        const eduItems = section.education || [section];
        return eduItems.map((edu, index) => (
          <div key={index}>
            <h3>{edu.institution}</h3>
            <p>{edu.degree}</p>
            {edu.thesis && <p>{edu.thesis}</p>}
          </div>
        ));
      } else if (section.content) {
        return <p>{section.content}</p>;
      } else {
        return (
          <div>
            {Object.entries(section).map(([key, value], index) => (
              <div key={index}>
                <strong>{key}: </strong>
                {renderSection(value)}
              </div>
            ))}
          </div>
        );
      }
    }
    return null;
  };

  return (
    <div>
      <h1 className="resume-heading">
        {content.title} <span style={{ animation: 'blink 1s infinite' }}>_</span>
      </h1>
      {Object.entries(content).map(([key, section]) => {
        if (key !== 'title' && typeof section === 'object') {
          return (
            <div key={key} className="resume-section">
              <h2 className="resume-heading">{section.title}</h2>
              {renderSection(section)}
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default ResumeContent;
